/* eslint-disable */

/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */

if (!customElements.get("variant-picker")) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest(".js-product");
      this.productForm = this.section.querySelector(".js-product-form-main");
      this.optionSelectors = this.querySelectorAll(".option-selector");
      this.data = this.getProductData();
      // Filter out hidden variants early
      this.data.product.variants = this.getVisibleVariants();
      this.variant = this.getSelectedVariant();
      this.selectedOptions = this.getSelectedOptions();
      this.preSelection =
        !this.variant && this.selectedOptions.find((o) => o === null) === null;

      this.addEventListener("change", this.handleVariantChange.bind(this));

      // Defer these to allow for quick-add modal to full initialize
      setTimeout(() => {
        this.updateAvailability();
        this.updateAddToCartButton();
        this.updateSelection();
        this.updatePreorder();
        document.querySelector('variant-picker[data-show-outofstock]').style.visibility = 'visible'

      });
    }

    /**
     * Filter variants based on hide metafield and inventory conditions
     * @returns {Array} Array of visible variants
     */
    getVisibleVariants() {
      const showOutOfStock = this.dataset.showOutofstock === 'true';

      return this.data.product.variants.filter(variant => {
        // Check if variant should be hidden based on metafield
        const hideMetafield = this.data.metafields[variant.id]?.hide;

        if (hideMetafield === "true" || hideMetafield === true) {
          return false; // Hide this variant
        }

        // Check inventory condition only if hide metafield is not true
        if (variant.inventory_quantity <= 0 && !showOutOfStock) {
          return false; // Hide this variant
        }

        return true; // Show this variant
      });
    }

    updateSelection(options) {
      var variantPicker = this;

      if(variantPicker.dataset.showOutofstock == 'false') {
        if(options != undefined) {
          var opAvailable = options.available;
          if(options.available) return;
          const selectedOption1 = options.option1; // Color that was selected
          const selectedOption2 = options.option2; // Size that was selected
          var availableVariant = this.data.product.variants.filter((variant) =>
            variant.available == true && variant.option2 === selectedOption2
          );

          if(availableVariant.length <= 0) {
            availableVariant = this.data.product.variants.filter((variant) => variant.available == true);
          }

          if(availableVariant.length <= 0) return;

          var firstAvailbleO1 = availableVariant[0].option1;
          var firstAvailbleO2 = availableVariant[0].option2;

          const input1 = this.section.querySelector('input[value="'+firstAvailbleO1+'"]');
          const input2 = this.section.querySelector('input[value="'+firstAvailbleO2+'"]');

          if(input1) input1.click();
          if(input2) input2.click();

        } else {
          if(this.variant && this.variant.available) return;

          var availableVariant = this.data.product.variants.filter((variant) => variant.available == true);
          if(availableVariant.length <= 0) return;

          var firstAvailbleO1 = availableVariant[0].option1;
          var firstAvailbleO2 = availableVariant[0].option2;

          const input1 = this.section.querySelector('input[value="'+firstAvailbleO1+'"]');
          const input2 = this.section.querySelector('input[value="'+firstAvailbleO2+'"]');

          if(input1) input1.click();
          if(input2) input2.click();
        }
      }
    }
    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      if (!this.section.contains(evt.target)) {
        return;
      }

      // Always clear overflow-x and overflow on body to prevent sticky hidden state
      document.body.style.overflowX = '';
      document.body.style.overflow = '';

      showLoader();
      this.selectedOptions = this.getSelectedOptions();
      this.variant = this.getSelectedVariant();
      this.targetid = evt.target.id;
      this.preSelection = !this.variant && this.selectedOptions.find((o) => o === null) === null;
      if (this.variant) {
        this.updateMedia();
        this.updateUrl(evt);
        this.updateVariantInput();
      }

      this.updateAddToCartButton();
      this.updateAvailability();
      if (this.variant && !this.variant.available) {
        this.updateSelection(this.variant);
      } else if (!this.variant) {
        this.updateSelection();
      }
      this.updatePrice();
      this.updateWeight();
      this.updateBarcode();
      this.updateBackorderText();
      this.updatePickupAvailability();
      this.updateSku();
      this.updateMetafieldVisibility();
      this.updateProductBadge();
      this.updatePreorder();
      this.updatePromoMessage();
      this.updateOfferText();
      this.updateInStockText();
      VariantPicker.updateVariantSelector(evt);
      if(this.targetid.indexOf('color') != -1) {
        VariantPicker.updateLabelText(evt);
      }

      if (!this.preSelection) {
        this.dispatchEvent(
          new CustomEvent("on:variant:change", {
            bubbles: true,
            detail: {
              form: this.productForm,
              variant: this.variant,
              product: this.data.product,
            },
          })
        );
      }
      setTimeout(() => {
        hideLoader();
      }, 1000);
    }

    /**
     * Shows/hides variant metafield elements on the page as necessary
     */
    updateMetafieldVisibility() {
      document.querySelectorAll("[data-variant-metafield]").forEach((elem) => {
        elem.classList.toggle(
          "hidden",
          elem.dataset.variantMetafield !== this.variant?.id.toString()
        );
      });
    }

    /**
     * Updates the "Add to Cart" button label and disabled state.
     */
    updateAddToCartButton() {
      this.productForm = this.section.querySelector(".js-product-form-main");
      if (!this.productForm) return;

      let preorder = false;
      let custombtnsvg = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false" role="presentation" class="icon"><path d="M12 2c2.761 0 5 2.089 5 4.667V8h2.2a.79.79 0 0 1 .8.778v12.444a.79.79 0 0 1-.8.778H4.8a.789.789 0 0 1-.8-.778V8.778A.79.79 0 0 1 4.8 8H7V6.667C7 4.09 9.239 2 12 2zm6.4 7.556H5.6v10.888h12.8V9.556zm-6.4-6c-1.84 0-3.333 1.392-3.333 3.11V8h6.666V6.667c0-1.719-1.492-3.111-3.333-3.111z"/></svg> `;

      // Calculate preorder status based on atf and ato values
      if(this.variant != undefined && this.data.metafields[this.variant.id] && theme.settings.preorder_enabled) {
        const variantATF = parseInt(this.data.metafields[this.variant.id].atf) || 0;
        const variantATO = parseInt(this.data.metafields[this.variant.id].ato) || 0;
        preorder = variantATF === 0 && variantATO > 0;
      }
      this.addBtn =
        this.addBtn || this.productForm.querySelector('[name="add"]');
      this.custombtn = document.querySelector('.custom_add_cart');

      const variantAvailable = this.variant && this.variant.available;

      let whichstorename = theme.strings.whichstore;
      let variantATF = 0;
      let variantATO = 0;

      if (this.variant) {
        variantATF = this.data.metafields[this.variant.id].atf;
        variantATO = this.data.metafields[this.variant.id].ato;
      }
      if(variantATO == undefined && !variantAvailable) {
        variantATO = 0
      }else if(variantATO == undefined && variantAvailable) {
        variantATO = 0
      }

      if(variantATF == undefined && !variantAvailable) {
        variantATF = 0
      }else if(variantATF == undefined && variantAvailable) {
        variantATF = 0
      }

      //  To do: E2E scenria testing for Dooney and Bourke. Logic of the ticket will be in DT-452 for more details
      //  Changes will be required here too
      if(whichstorename == 'dooneyandbourke') {
        this.addBtn.disabled =  this.preSelection || (!variantAvailable && variantATO == 0);
        if(this.custombtn) {
          this.custombtn.disabled = this.preSelection || (!variantAvailable && variantATO == 0);
        }
      }else {
        this.addBtn.disabled =  this.preSelection || (!variantAvailable && variantATF == 0);
        if(this.custombtn) {
          this.custombtn.disabled = this.preSelection || (!variantAvailable && variantATF == 0);
        }
      }

      if (this.preSelection) {
        this.addBtn.textContent = theme.strings.noSelectedVariant;
        if(this.custombtn) {
          this.custombtn.innerHTML = custombtnsvg + theme.strings.noSelectedVariant;
        }
      } else {
        const unavailableStr = this.variant
          ? theme.strings.noStock
          : theme.strings.noVariant;

        // Determine button text based on preorder status and availability
        let buttonText = this.addBtn.dataset.addToCartText;

        if (preorder) {
          // If preorder is true, show preorder text
          buttonText = theme.strings.preorder || "Preorder";
        } else if (whichstorename == 'dooneyandbourke') {
          buttonText = variantATO > 0 && variantAvailable
            ? this.addBtn.dataset.addToCartText
            : unavailableStr;
        } else {
          buttonText = variantATF > 0 && variantAvailable
            ? this.addBtn.dataset.addToCartText
            : unavailableStr;
        }

        this.addBtn.textContent = buttonText;

        if(this.custombtn) {
          this.custombtn.innerHTML = `${custombtnsvg} ${buttonText}`;
        }
      }

      if ((whichstorename == 'dooneyandbourke' && !variantAvailable && variantATO == 0) || (!variantAvailable && variantATF == 0)) {
        this.addBtn.textContent = theme.strings.soldOut || "Sold Out";
        if(this.custombtn) {
          this.custombtn.innerHTML = `${custombtnsvg} ${theme.strings.soldOut}`;
          this.custombtn.disabled = true;
        }
        this.addBtn.disabled = true;
      } else {
        // Set button text based on preorder status
        const buttonText = preorder
          ? (theme.strings.preorder || "Preorder")
          : (theme.strings.addToCart || "Add to cart");

        this.addBtn.textContent = buttonText;
        if(this.custombtn) {
          this.custombtn.innerHTML = `${custombtnsvg} ${buttonText}`;
          this.custombtn.disabled = false;
        }
      }
    }

    /**
     * Updates the availability status of an option.
     * @param {Element} optionEl - Option element.
     * @param {boolean} exists - Does this option lead to a variant that exists?
     * @param {boolean} available - Does this option lead to a variant that is available to buy?
     */
    static updateOptionAvailability(optionEl, exists, available) {
      const el = optionEl;
      const unavailableText = exists
        ? theme.strings.noStock
        : theme.strings.noVariant;

      el.classList.toggle("is-unavailable", !available);
      el.classList.toggle("is-nonexistent", !exists);

      if (optionEl.classList.contains("custom-select__option")) {
        const em = el.querySelector("em");

        if (em) {
          em.hidden = available;
        }

        if (!available) {
          if (em) {
            em.textContent = unavailableText;
          } else {
            el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${unavailableText}</em>`;
          }
        }
      } else if (!available) {
        el.nextElementSibling.title = unavailableText;
      } else {
        el.nextElementSibling.removeAttribute("title");
      }
    }

    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability() {
      if (this.dataset.showAvailability === "false") return;
      const { availabilityMethod } = this.dataset; // 'downward' or 'selection'
      let currVariant = this.variant;

      // if(currVariant.available == false) {
      //   return;
      // }

      if (!this.variant) {
        currVariant = { options: this.selectedOptions };
      }

      if (availabilityMethod === "selection") {
        // Flag all options as unavailable
        this.querySelectorAll(".js-option:not(.is-unavailable)").forEach((optionEl) => {
          VariantPicker.updateOptionAvailability(optionEl, false, false);
        });

        // Flag selector options as available or sold out, depending on the variant availability
        this.optionSelectors.forEach((selector, selectorIndex) => {
          this.data.product.variants.forEach((variant) => {
            let matchCount = 0;

            variant.options.forEach((option, optionIndex) => {
              if (
                option === currVariant.options[optionIndex] &&
                optionIndex !== selectorIndex
              ) {
                matchCount += 1;
              }
            });

            if (matchCount === currVariant.options.length - 1) {
              const options = selector.querySelectorAll(".js-option");
              const optionEl = Array.from(options).find((opt) => {
                if (selector.dataset.selectorType === "dropdown") {
                  return opt.dataset.value === variant.options[selectorIndex];
                }
                return opt.value === variant.options[selectorIndex];
              });

              if (optionEl) {
                VariantPicker.updateOptionAvailability(
                  optionEl,
                  true,
                  variant.available
                );
              }
            }
          });
        });
      } else {
        this.optionSelectors.forEach((selector, selectorIndex) => {
          const options = selector.querySelectorAll(
            '.js-option:not([data-value=""])'
          );
          options.forEach((option) => {
            const optionValue =
              selector.dataset.selectorType === "dropdown"
                ? option.dataset.value
                : option.value;
            // any available variants with previous options and this one locked in?
            let variantsExist = false;
            let variantsAvailable = false;
            this.data.product.variants.forEach((v) => {
              let matches = 0;
              for (let i = 0; i < selectorIndex; i += 1) {
                if (
                  v.options[i] === this.selectedOptions[i] ||
                  this.selectedOptions[i] === null
                ) {
                  matches += 1;
                }
              }
              if (
                v.options[selectorIndex] === optionValue &&
                matches === selectorIndex
              ) {
                variantsExist = true;
                if (v.available) {
                  variantsAvailable = true;
                }
              }
            });
            VariantPicker.updateOptionAvailability(
              option,
              variantsExist,
              variantsAvailable
            );
          });
        });
      }
      // Hide promo groups where all variants are unavailable
      setTimeout(() => {
        const variantGroups = this.querySelectorAll('.variant-group');

        variantGroups.forEach(group => {
          const groupInputs = group.querySelectorAll('.js-option');
          const unavailableInputs = group.querySelectorAll('.js-option.is-unavailable');

          // If all inputs in this group are unavailable, hide the entire group
          if (groupInputs.length > 0 && groupInputs.length === unavailableInputs.length) {
            group.style.display = 'none';
          } else {
            group.style.display = '';
          }
        });
      }, 100);
    }

    /**
     * Updates the backorder text and visibility.
     */
    updateBackorderText() {
      this.backorder =
        this.backorder || this.section.querySelectorAll(".product-backorder-message");
      if (this.backorder.length == 0) return;

      // let hideBackorder = true;

      if (this.variant && this.variant.available) {
        const inventory = this.data.formatted[this.variant.id];

        this.backorder.forEach((el) => {
           if(el.dataset.variantid == this.variant.id) {
            el.hidden = false;
           }else {
            el.hidden = true;
           }
        })
      }

      // this.backorder.hidden = hideBackorder;
    }

    /**
     * Updates the color option label text.
     * @param {object} evt - Event object
     */
    static updateLabelText(evt) {

      const colorText = document.querySelector(".js-color-text");
      if (!colorText) return;

      colorText.textContent =
        evt.target.nextElementSibling.querySelector(".js-value").textContent;
    }

    static updateVariantSelector(evt) {

        const otherText = document.querySelector(".js-other-text");
        if (!otherText) return;
        if (evt.target.nextElementSibling.querySelector(".js-other-value")) {
        otherText.textContent = evt.target.nextElementSibling.querySelector(".js-other-value").textContent;
        }
    }

    /**
     * Updates the product media.
     */
    updateMedia() {
      if (!this.variant.featured_media) return;

      if (this.section.matches("quick-add-drawer")) {
        this.section.updateMedia(this.variant.featured_media.id);
      } else {
        this.mediaGallery =
          this.mediaGallery || this.section.querySelector("media-gallery");
        if (!this.mediaGallery) return;

        const variantMedia = this.mediaGallery.querySelector(
          `[data-media-id="${this.variant.featured_media.id}"]`
        );
        this.mediaGallery.setActiveMedia(variantMedia, true, true);
      }
    }

    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability =
        this.pickUpAvailability ||
        this.section.querySelector("pickup-availability");
      if (!this.pickUpAvailability) return;

      if (this.variant && this.variant.available) {
        this.pickUpAvailability.getAvailability(this.variant.id);
      } else {
        this.pickUpAvailability.removeAttribute("available");
        this.pickUpAvailability.innerHTML = "";
      }
    }

    /**
     * Updates the price.
     */
    updatePrice() {
      this.price =
        this.price ||
        this.section.querySelector(".product-info__price > .price");
      if (!this.price) return;

      let { variant } = this;
      if (this.preSelection) {
        variant = this.data.product.variants[0];
        for (let i = 1; i < this.data.product.variants.length; i += 1) {
          if (this.data.product.variants[i].price < variant.price)
            variant = this.data.product.variants[i];
        }
      }

      if (this.variant) {
        const priceCurrentEl = this.price.querySelector(".price__current");
        const priceWasEl = this.price.querySelector(".price__was");
        const unitPriceEl = this.price.querySelector(".unit-price");

        // Update current price and original price if on sale.
        priceCurrentEl.innerHTML = this.data.formatted[this.variant.id].price;
        if (priceWasEl)
          priceWasEl.innerHTML =
            this.data.formatted[this.variant.id].compareAtPrice || "";

        // Update unit price, if specified.
        if (this.variant.unit_price_measurement) {
          const valueEl = this.price.querySelector(".unit-price__price");
          const unitEl = this.price.querySelector(".unit-price__unit");
          const value = this.variant.unit_price_measurement.reference_value;
          const unit = this.variant.unit_price_measurement.reference_unit;

          valueEl.innerHTML = this.data.formatted[this.variant.id].unitPrice;
          unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
        }

        unitPriceEl.hidden = !this.variant.unit_price_measurement;
        this.price.classList.toggle(
          "price--on-sale",
          this.variant.compare_at_price > this.variant.price
        );
        this.price.classList.toggle(
          "price--sold-out",
          !this.variant.available && !this.preSelection
        );
      }

      this.price.querySelector(".price__default").hidden =
        !this.variant && !this.preSelection;
      this.price.querySelector(".price__no-variant").hidden =
        this.variant || this.preSelection;
      const from = this.price.querySelector(".price__from");
      if (from) {
        from.hidden = !this.preSelection;
      }
    }

    /**
     * Updates the product badge.
     */
    updateProductBadge() {
      this.productBadgeContainer =
        this.productBadgeContainer ||
        this.section.querySelector(".product-label-container");
      this.productBadge =
        this.productBadge || this.section.querySelector(".product-badge-label");
      if (!this.productBadgeContainer || !this.productBadge) return;
      let badgeMetafield = false;
      if(this.variant != undefined) {
        badgeMetafield = this.data.metafields[this.variant.id].badgeLabel;
      }
      if (badgeMetafield) {
        const badgeMetafieldHandle = badgeMetafield
          ? badgeMetafield.toLowerCase().replace(/[^a-z0-9\s-_]/g, '').replace(/[\s_]+/g, '-').replace(/-+/g, '-').replace(/^-+|-+$/g, '')
          : "";
        this.productBadge.setAttribute(
          "data-badge-label",
          badgeMetafieldHandle || ""
        );
        this.productBadge.innerHTML = badgeMetafield;
        this.productBadgeContainer.classList.add("block");
        this.productBadgeContainer.classList.remove("hidden");
      } else {
        this.productBadgeContainer.classList.remove("block");
        this.productBadgeContainer.classList.add("hidden");
      }
    }

    /**
     * Updates the preorder text and button, and notify me section.
     */
    updatePreorder() {
      this.preorder =
        this.preorder || this.section.querySelector(".preorder-message");
      this.preorderDateContainer =
        this.preorderDateContainer ||
        this.section.querySelector(".preorder-date");
      this.notifyMeSection =
        this.notifyMeSection || this.section.querySelector("[data-notify-form-id]");
      if (!this.variant) {
        if (this.preorder) {
          this.preorder.classList.remove("flex");
          this.preorder.classList.add("hidden");
        }
        if (this.notifyMeSection) {
          this.notifyMeSection.classList.add("hidden");
        }
        return;
      }

      let variantATF = 0;
      let variantATO = 0;
      let preorderDate = '';

      if (this.variant && this.data.metafields[this.variant.id]) {
        variantATF = parseInt(this.data.metafields[this.variant.id].atf) || 0;
        variantATO = parseInt(this.data.metafields[this.variant.id].ato) || 0;
        preorderDate = this.data.metafields[this.variant.id].preorderDate || '';
      }

      const shouldShowPreorder = variantATF === 0 && variantATO > 0 && theme.settings.preorder_enabled;

      this.updatePreorderFormFields(shouldShowPreorder, preorderDate);

      // Handle preorder message
      if (this.preorder) {
        if (shouldShowPreorder && preorderDate) {
          this.preorder.classList.remove("hidden");
          this.preorder.classList.add("flex");

          if (this.preorderDateContainer) {
            this.preorderDateContainer.textContent = preorderDate;
          }
        } else {
          this.preorder.classList.remove("flex");
          this.preorder.classList.add("hidden");
        }
      }

      // Handle notify me section
      if (this.notifyMeSection) {
        if (shouldShowPreorder) {
          this.notifyMeSection.classList.remove("hidden");
        } else {
          this.notifyMeSection.classList.add("hidden");
          const productForm = this.section.querySelector('product-form');
          const formId = productForm?.dataset?.notifyFormId || null;
          const targetForm = formId ? document.querySelector('[data-forms-id="forms-root-' + formId + '"]') : null;
          if (targetForm) {
            const appBlock = targetForm.closest('.shopify-app-block, [data-app-block="shopify-forms"], .product-info__block[data-shopify-app-block]');
            if (appBlock) {
              appBlock.style.display = 'none';
              appBlock.classList.add('hidden');
            }
          }
        }
      }
    }

     /**
     * Updates the hidden preorder form fields based on variant selection.
     * @param {boolean} shouldShowPreorder - Whether the variant should be in preorder state
     * @param {string} preorderDate - The preorder ship date
     */
    updatePreorderFormFields(shouldShowPreorder, preorderDate) {
      const productForm = this.productForm || this.section.querySelector('.js-product-form-main');
      if (!productForm) return;

      // Handle the _preorder field
      let preorderField = productForm.querySelector('input[name="properties[_preorder]"]');
      if (shouldShowPreorder) {
        if (!preorderField) {
          preorderField = document.createElement('input');
          preorderField.type = 'hidden';
          preorderField.name = 'properties[_preorder]';
          productForm.appendChild(preorderField);
        }
        preorderField.value = 'true';
      } else {
        preorderField.value = 'false';
      }

      // Handle the Pre-Order message field
      let preorderMessageField = productForm.querySelector('input[name="properties[Pre-Order]"]');
      if (shouldShowPreorder && preorderDate) {
        // Parse and format the date
        const dateObj = new Date(preorderDate);
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        const formattedDate = dateObj.toLocaleDateString('en-US', options);

        if (!preorderMessageField) {
          preorderMessageField = document.createElement('input');
          preorderMessageField.type = 'hidden';
          preorderMessageField.name = 'properties[Pre-Order]';
          productForm.appendChild(preorderMessageField);
        }
        // Use the same format as in the translation

        const preOrderTextTemplate =
          theme.strings.preorder_message || "Estimated Ship Date: [ship_date]";
        const preorderText = preOrderTextTemplate.replace("[ship_date]", formattedDate);
        preorderMessageField.value = preorderText;
      } else {
        // Remove the field if not a preorder with date
        if (preorderMessageField) {
          preorderMessageField.remove();
        }
      }
    }

    /**
     * Updates the promo message.
     **/
    updatePromoMessage() {
      this.promoMessage =
        this.promoMessage ||
        this.section.querySelector(".product-page-promo-message");
      if (!this.promoMessage) return;
      let promoMessage = false;
      if(this.variant != undefined) {
        promoMessage = this.data.metafields[this.variant.id].promoMessage;
      }
      if (promoMessage) {
        this.promoMessage.classList.remove("hidden");
        this.promoMessage.classList.add("flex");
        this.promoMessage.textContent = promoMessage;
      } else {
        this.promoMessage.classList.remove("flex");
        this.promoMessage.classList.add("hidden");
      }
    }

    /**
     * Updates the offer text.
     **/
    updateOfferText() {
      this.offerText =
        this.offerText || this.section.querySelector(".offered_at_text");
      if (!this.offerText) return;
      let offeredAtPrice = '';
      let offeredAtDate = '';
      if(this.variant != undefined) {
        offeredAtPrice =
          this.data.metafields[this.variant.id].offeredAtPrice;
        offeredAtDate = this.data.metafields[this.variant.id].offeredAtDate;
      }
      if (offeredAtPrice && offeredAtDate) {
        const offerTextTemplate =
          theme.strings.offered_at || "Offered at [price] starting in [date]";
        const offerText = offerTextTemplate
          .replace("[price]", offeredAtPrice)
          .replace("[date]", offeredAtDate);
        this.offerText.classList.remove("hidden");
        this.offerText.classList.add("flex");
        this.offerText.textContent = offerText;
      } else {
        this.offerText.classList.remove("flex");
        this.offerText.classList.add("hidden");
      }
    }

    updateInStockText() {
      this.inStockText =
        this.inStockText || this.section.querySelector(".in-stock-text");
      if (!this.inStockText) return;
      let inStock = false;
      if(this.variant != undefined) {
        inStock = this.data.metafields[this.variant.id].atf;
      }
      if (inStock > 0) {
        this.inStockText.classList.remove("hidden");
        this.inStockText.classList.add("flex");
        this.inStockText.textContent = theme.strings.inStock || "In Stock";
      } else {
        this.inStockText.classList.remove("flex");
        this.inStockText.classList.add("hidden");
      }
    }

    /**
     * Updates the weight.
     */
    updateWeight() {
      this.weights =
        this.weights || this.section.querySelectorAll(".product-info__weight");
      if (this.weights.length === 0) return;

      const weightAvailable = this.variant && this.variant.weight > 0;
      this.weights.forEach((weight) => {
        weight.textContent = weightAvailable
          ? this.data.formatted[this.variant.id].weight
          : "";
        weight.hidden = !weightAvailable;
      });
    }

    /**
     * Updates the Barcode.
     */
    updateBarcode() {
      this.barcodes =
        this.barcodes ||
        this.section.querySelectorAll(".product-info__barcode-value");
      if (this.barcodes.length === 0) return;

      const barcodeAvailable = this.variant && this.variant.barcode;
      this.barcodes.forEach((barcode) => {
        barcode.textContent = barcodeAvailable ? this.variant.barcode : "";
        barcode.parentNode.hidden = !barcodeAvailable;
      });
    }

    /**
     * Updates the SKU.
     */
    updateSku() {
      this.sku = this.sku || this.section.querySelector(".product-sku__value");
      if (!this.sku) return;

      const skuAvailable = this.variant && this.variant.sku;
      this.sku.textContent = skuAvailable ? this.variant.sku : "";
      this.sku.parentNode.hidden = !skuAvailable;
    }

    /**
     * Updates the url with the selected variant id.
     * @param {object} evt - Event object.
     */
    updateUrl(evt) {
      if (!evt || evt.type !== "change" || this.dataset.updateUrl === "false")
        return;
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.variant.id}`
      );
    }

    /**
     * Updates the value of the variant ID input in the main product form only.
     */
    updateVariantInput() {
      // Only update the main product form's variant input
      const mainProductForm = this.section.querySelector('.js-product-form-main');
      if (mainProductForm) {
        const input = mainProductForm.querySelector('.js-variant-id');
        if (input) {
          input.value = this.variant.id;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
    }

    /**
     * Gets the selected option element from each selector.
     * @returns {Array}
     */
    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === "dropdown") {
          const selectedText = selector
            .querySelector(".custom-select__btn")
            .textContent.trim();
          selectedOptions.push(
            selectedText === this.dataset.placeholderText ? null : selectedText
          );
        } else {
          const selected = selector.querySelector("input:checked");
          selectedOptions.push(selected ? selected.value : null);
        }
      });
      return selectedOptions;
    }

    /**
     * Gets the product data.
     * @returns {?object}
     */
    getProductData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }

    /**
     * Get selected variant data.
     * @returns {?object} Variant object, or null if one is not selected.
     */
    getSelectedVariant() {
      const selectedOptions = this.getSelectedOptions();
      return this.data.product.variants.find((v) =>
        v.options.every((val, index) => val === selectedOptions[index])
      );
    }
  }

  customElements.define("variant-picker", VariantPicker);
}